import { TrackingBaseData } from '@/reducers/tracking/types';
import api from '../config/api';
import { BannerRequest, BannerResponse, TrackingRequest } from './types';

export const getBannerApi = (payload: BannerRequest) =>
  api.get<BannerResponse>(`/publicApiV2/cms/${payload.bannerTag}`, {
    params: { retailerToken: payload.retailerToken },
  });

export const getPointDetailApi = (pointId: number) =>
  api.get('/publicApiV2/point/detail', {
    params: {
      'filter.base.ids': pointId,
      'filter.coordinates': true,
    },
  });

export const getTrackingInfoApi = (payload: TrackingRequest) =>
  api.get<TrackingBaseData>(
    `/publicApiV2/tracking/base/${payload.pickitNumber}`,
    {
      headers: { Grecaptcharesponse: payload.recaptchaToken },
      params: {
        token: payload.retailerToken,
      },
    },
  );
